var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fav-property_svg__nc-icon-wrapper",
    stroke: "#111",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5L8 .5l-7.5 7M2.5 8.5v7h11v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.941 7.53A1.95 1.95 0 008 7.846a1.95 1.95 0 00-2.941-.316 1.813 1.813 0 000 2.618L8 13l2.941-2.852a1.813 1.813 0 000-2.618z",
    "data-color": "color-2"
  }))));
}

export default SvgFavProperty;